// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu_closeIConn__fZ23E {
    display: flex;
    justify-content: flex-end;
    color: #4769a3;
    font-weight: 400;
}

.Menu_sidebarClosed__99imX {
    transform: translateX(-100vw);
    transition: 1.0s ;
    background-color: #5C80BC;
    height: 100vh;
}

@media screen and (min-width:1024px) {
    .Menu_sidebar__Guv5G {
        margin: 0;
        height: 100vh;
        font-size: 20px;
        background-color: #5C80BC;
        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);
        transition: 0.8s ;
    }

    .Menu_sidebar__Guv5G .Menu_item__OTwn2  {
        color: white;
        cursor: pointer;
        display: flex;
        height: 60px;
        margin-left: -10%;
        padding-left: 15%;
        flex-direction: row;
        align-items: center;
        transition: all .8s;
    }

    .Menu_sidebar__Guv5G .Menu_itemClicado__qxJy7 {
        color: #374A67;
        background-color: rgba(255, 255, 255, 0.655);
        width: 93%;
        cursor: pointer;
        display: flex;
        height: 55px;
        padding-left: 5%;
        margin-left: -3px;
        flex-direction: row;
        align-items: center;
        transition: all .8s;
        border-radius: 5px;
    }

    .Menu_item__OTwn2:hover,
    .Menu_itemClicado__qxJy7:hover {
        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);
        width: 93%;
        padding-left: 5%;
        margin-left: -3px;
    }

    .Menu_icon__e41M\\+ {
        margin-right: 10%;
    }

}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px) {
    .Menu_sidebar__Guv5G {
        margin: 0;
        height: 100vh;
        font-size: 17px;
        background-color: #00559A;
        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);
    }

    .Menu_sidebar__Guv5G .Menu_item__OTwn2 {
        color: white;
        padding-left: 20%;
        cursor: pointer;
        transition: all 1.0s;
        display: flex;
        flex-direction: row;
        max-height: 30%;
        margin-left: -10%;
        align-items: center;
    }

    .Menu_sidebar__Guv5G .Menu_itemClicado__qxJy7 {
        color: #00559A;
        background-color: white;
        padding-left: 15%;
        cursor: pointer;
        transition: all 1.0s;
        display: flex;
        flex-direction: row;
        max-height: 30%;
        margin-left: -10%;
        align-items: center;
    }

    .Menu_item__OTwn2:hover,
    .Menu_itemClicado__qxJy7:hover {
        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);
    }

    .Menu_icon__e41M\\+ {
        margin-right: 10%;
    }

}

/*MOBILE*/
@media screen and (max-width:767px) {
    .Menu_sidebar__Guv5G {
        bottom: 0px;
        margin: 0;
        height: 45px;
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        width: 100%;
        position: absolute;
        align-items: center;
        justify-content: space-evenly;
        background-color: #00559A;
        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.5);
    }

    .Menu_sidebar__Guv5G .Menu_item__OTwn2 {
        color: white;
        cursor: pointer;
        margin: 0;
    }

    .Menu_sidebar__Guv5G .Menu_itemClicado__qxJy7 {
        color: #000;
        ;
        cursor: pointer;
    }

    .Menu_item__OTwn2,
    .Menu_itemClicado__qxJy7 {
        padding: 20px 20px 10px 20px;
    }

    .Menu_item__OTwn2:hover,
    .Menu_itemClicado__qxJy7:hover {
        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);
    }

    li p {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/menu/Menu.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI;QACI,SAAS;QACT,aAAa;QACb,eAAe;QACf,yBAAyB;QACzB,4CAA4C;QAC5C,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,4CAA4C;QAC5C,UAAU;QACV,eAAe;QACf,aAAa;QACb,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;;QAEI,4CAA4C;QAC5C,UAAU;QACV,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA,SAAS;AACT;IACI;QACI,SAAS;QACT,aAAa;QACb,eAAe;QACf,yBAAyB;QACzB,4CAA4C;IAChD;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;;QAEI,4CAA4C;IAChD;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA,SAAS;AACT;IACI;QACI,WAAW;QACX,SAAS;QACT,YAAY;QACZ,aAAa;QACb,eAAe;QACf,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,6BAA6B;QAC7B,yBAAyB;QACzB,4CAA4C;IAChD;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,SAAS;IACb;;IAEA;QACI,WAAW;;QAEX,eAAe;IACnB;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,4CAA4C;IAChD;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".closeIConn {\n    display: flex;\n    justify-content: flex-end;\n    color: #4769a3;\n    font-weight: 400;\n}\n\n.sidebarClosed {\n    transform: translateX(-100vw);\n    transition: 1.0s ;\n    background-color: #5C80BC;\n    height: 100vh;\n}\n\n@media screen and (min-width:1024px) {\n    .sidebar {\n        margin: 0;\n        height: 100vh;\n        font-size: 20px;\n        background-color: #5C80BC;\n        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);\n        transition: 0.8s ;\n    }\n\n    .sidebar .item  {\n        color: white;\n        cursor: pointer;\n        display: flex;\n        height: 60px;\n        margin-left: -10%;\n        padding-left: 15%;\n        flex-direction: row;\n        align-items: center;\n        transition: all .8s;\n    }\n\n    .sidebar .itemClicado {\n        color: #374A67;\n        background-color: rgba(255, 255, 255, 0.655);\n        width: 93%;\n        cursor: pointer;\n        display: flex;\n        height: 55px;\n        padding-left: 5%;\n        margin-left: -3px;\n        flex-direction: row;\n        align-items: center;\n        transition: all .8s;\n        border-radius: 5px;\n    }\n\n    .item:hover,\n    .itemClicado:hover {\n        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);\n        width: 93%;\n        padding-left: 5%;\n        margin-left: -3px;\n    }\n\n    .icon {\n        margin-right: 10%;\n    }\n\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px) {\n    .sidebar {\n        margin: 0;\n        height: 100vh;\n        font-size: 17px;\n        background-color: #00559A;\n        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);\n    }\n\n    .sidebar .item {\n        color: white;\n        padding-left: 20%;\n        cursor: pointer;\n        transition: all 1.0s;\n        display: flex;\n        flex-direction: row;\n        max-height: 30%;\n        margin-left: -10%;\n        align-items: center;\n    }\n\n    .sidebar .itemClicado {\n        color: #00559A;\n        background-color: white;\n        padding-left: 15%;\n        cursor: pointer;\n        transition: all 1.0s;\n        display: flex;\n        flex-direction: row;\n        max-height: 30%;\n        margin-left: -10%;\n        align-items: center;\n    }\n\n    .item:hover,\n    .itemClicado:hover {\n        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);\n    }\n\n    .icon {\n        margin-right: 10%;\n    }\n\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n    .sidebar {\n        bottom: 0px;\n        margin: 0;\n        height: 45px;\n        display: flex;\n        flex-wrap: wrap;\n        padding: 0;\n        width: 100%;\n        position: absolute;\n        align-items: center;\n        justify-content: space-evenly;\n        background-color: #00559A;\n        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.5);\n    }\n\n    .sidebar .item {\n        color: white;\n        cursor: pointer;\n        margin: 0;\n    }\n\n    .sidebar .itemClicado {\n        color: #000;\n        ;\n        cursor: pointer;\n    }\n\n    .item,\n    .itemClicado {\n        padding: 20px 20px 10px 20px;\n    }\n\n    .item:hover,\n    .itemClicado:hover {\n        box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1);\n    }\n\n    li p {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeIConn": `Menu_closeIConn__fZ23E`,
	"sidebarClosed": `Menu_sidebarClosed__99imX`,
	"sidebar": `Menu_sidebar__Guv5G`,
	"item": `Menu_item__OTwn2`,
	"itemClicado": `Menu_itemClicado__qxJy7`,
	"icon": `Menu_icon__e41M+`
};
export default ___CSS_LOADER_EXPORT___;
